import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

import "@fortawesome/fontawesome-free/css/all.min.css";

import Landing from "views/Landing.js";
import Documentation from "views/documentation";
import Pricing from "views/pricing";
import Terms from "views/terms";
import Privacy from "views/privacy";



ReactDOM.render(
  <BrowserRouter>
    <Switch>
      <Route path='/home' component={Landing} />
      <Route path='/pricing' component={Pricing} />
      <Route path='/terms' component={Terms} />
      <Route path='/privacy' component={Privacy} />
      <Route path='/documentation' component={Documentation} />
      <Route path='/suppport' component={Landing} />
      <Redirect from='/' to='/home' />
    </Switch>
  </BrowserRouter>,
  document.getElementById("root")
);
